<template>
  <img v-bind="$attrs" class="img-fluid" />
</template>

<script>
export default {
  name: "ImageViewer",
};
</script>

<style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
